(()=>{
 const S=window.GB_SHOPIFY;let complete=true;
 for(const p of GB_CATALOG.products.filter(p=>p.availability==='active')){
  const product=GB_PRODUCTS[p.id];
  if(product?.id){p.shopifyProduct=product;p.productRoute=S.root+'products/'+product.handle;}
  for(const size of p.variants){
   const variants=product?.variants||[];
   const find=display=>variants.find(v=>[size.name,GB_I18N.t(size.name)].includes(v.option1)&&[display,GB_I18N.t(display)].includes(v.option2));
   const crystal=p.singleSize?variants[0]:find('Crystal Only'),oak=p.oakBaseAvailable?find('Oak LED Base'):null;
   size.shopifyId=crystal?.id||null;size.oakShopifyId=oak?.id||null;
   size.available=crystal?.available===true;size.oakAvailable=oak?.available===true;
   if(!crystal||Number(crystal.price)<=0||p.oakBaseAvailable&&(!oak||Number(oak.price)<Number(crystal.price)))complete=false;
   if(crystal&&Number(crystal.price)>0){size.priceCents=Number(crystal.price);size.oakPriceCents=oak?Number(oak.price)-Number(crystal.price):null;}
  }
  p.startingPrice=Math.min(...p.variants.map(v=>v.priceCents))/100;
 }
 GB_CATALOG.currency=S.currency;
 if(!S.referenceMode)S.pricingReady=complete;
 S.catalogReady=S.referenceMode||complete;
})();

window.GB_FALLBACK_PAGE=path=>{if(path==='/contact')return 'contact';const p=GB_CATALOG.products.find(p=>p.availability==='active'&&path==='/pages/personalized-3d-'+p.id+'-crystal');return p?'product-'+p.id:(path==='/collections/all'?'shop':'home');};
